(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cma-design-interest"] && !Shopify.designMode) return;
  try {
    
  if (!window.cmaDesignInterestBound) {
    window.cmaDesignInterestBound = true;
    document.addEventListener('click', function (event) {
      const link = event.target.closest('[data-cma-interest-design]');
      if (!link) return;
      const select = document.querySelector('#cma-design-notify [data-cma-design-select]');
      if (!select) return;
      let design = link.dataset.cmaInterestDesign;
      if (design === 'poppi') {
        const view = link.closest('.cma-dlp-family')?.querySelector('input[type="radio"]:checked');
        if (view && Number(view.value) >= 3) design = 'poppi-longneck';
      }
      const option = Array.from(select.options).find(function (item) { return item.dataset.design === design; });
      if (!option) return;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.focus({ preventScroll: true });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cma-family-specifications"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => root.querySelectorAll('[data-family-gallery]').forEach((gallery) => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const track = gallery.querySelector('.cma-family-specifications__track');
    const buttons = [...gallery.querySelectorAll('[data-slide-index]')];
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    buttons.forEach((button, index) => button.addEventListener('click', () => {
      track.scrollTo({left: track.clientWidth * index, behavior: preference.matches ? 'instant' : 'smooth'});
    }));
    track.addEventListener('scroll', () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }, {passive: true});
  });
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cma-venture-feature"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    root.querySelectorAll('.cma-venture-feature__video').forEach((video) => {
      if (video.dataset.cmaMotionReady) return;
      video.dataset.cmaMotionReady = 'true';
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      let manualControl = false;
      video.addEventListener('pointerdown', () => { manualControl = true; });
      video.addEventListener('keydown', () => { manualControl = true; });
      preference.addEventListener('change', () => {
        if (preference.matches) video.pause();
      });
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) video.pause();
          else if (!preference.matches && !manualControl) video.play().catch(() => {});
        });
      }, { threshold: 0.25 });
      observer.observe(video);
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
